<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Oops...</h1>
      <h2 class="subtitle">Could not find any entries here!</h2>
      <p>
        Go
        <strong>
          <a @click="$router.go(-1)">back</a>
        </strong> to the listing
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: "NoResult"
};
</script>